import { axiosV4 } from "../../../Utils/Axios/axiosV4";
export const buyKonkurBookletPdfService = async (
  userToken: string,
  pdfId: string | number,
  payWithWallet: number,
  payWithGiftWallet: number,
) => {
  const data = new FormData();
  data.append("konkur_booklet_pdf_id", String(pdfId));
  data.append("pay_with_wallet", String(payWithWallet));
  data.append("pay_with_gift_wallet", String(payWithGiftWallet));
  return axiosV4.post("user/konkur-booklets/buy-pdf", data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
